<template>
  <v-content>
    <v-container fluid grid-list-xs text-xs-center>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar class="primary" dense dark card>
              <v-toolbar-title>{{$t('manuales.manuales')}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text text-xs-left>
              <v-toolbar dense card color="white">
                <v-toolbar-title>{{$t('manuales.especificos')}}</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-list-tile v-for="item in ArchivosEspecificos" :key="item.Nombre">
                  <v-list-tile-action>
                    <v-icon color="dark">book</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <a :href="item.Ruta" target="_blank">{{item.Nombre}}</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <hr>
              <v-toolbar dense card color="white">
                <v-toolbar-title>{{$t('manuales.generales')}}</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-list-tile v-for="item in ArchivosGenericos" :key="item.Nombre">
                  <v-list-tile-action>
                    <v-icon color="dark">book</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <a :href="item.Ruta" target="_blank">{{item.Nombre}}</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <hr>
              <v-toolbar dense card color="white">
                <v-toolbar-title>{{$t('manuales.oficina')}}</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-list-tile v-for="item in ArchivosOficina" :key="item.Nombre">
                  <v-list-tile-action>
                    <v-icon color="dark">book</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <a :href="item.Ruta" target="_blank">{{item.Nombre}}</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Documentos",
  data() {
    return {
      ArchivosGenericos: [],
      ArchivosEspecificos: [],
      ArchivosOficina: []
    };
  },
  created: async function() {
    let res = await this.fetchDocuments(this.Login.DATOS.CLIENTE);
    this.ArchivosGenericos = res.respuesta.ArchivosGenericos;
    this.ArchivosEspecificos = res.respuesta.ArchivosEspecificos;
    this.ArchivosOficina = res.respuesta.ArchivosOficina;
  },
  methods: {
    ...mapActions("documents", ["fetchDocuments"])
  },
  computed: {
    ...mapGetters({ Login: "Auth/Usuario" })
  }
};
</script>
